import adminFuseHoc from "common/HOC/adminFuseHoc";
import AdminTeamsComponent from "./adminTeams.component";

export default adminFuseHoc(AdminTeamsComponent);
